import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@getro/rombo';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Download } from 'lucide-react';

import toast from 'react-hot-toast';
import { useExportAdminsMutation } from 'services/organizations';
import { activeNetworkSelector } from '../../../../redux/selectors';
import { trackEvent } from '../../../../helpers/analytics';

const ExportData = () => {
  const activeNetwork = useSelector(activeNetworkSelector);

  const [exportAdmins, { isLoading: isExportingAdmins }] = useExportAdminsMutation();

  return (
    <Box>
      <Text fontSize="14px" fontWeight="medium" color="text.dark">
        Admin list export
      </Text>
      <Text fontSize="14px" mt="8px">
        Export a list of everyone who can manage information displayed on your job board, including all network admins
        and company admins.{' '}
        <a
          href="https://help.getro.com/support/solutions/articles/65000168380-how-to-get-a-list-of-all-getrojobs-admins"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more
        </a>
        .
      </Text>
      <Button
        size="small"
        mt="16px"
        variant="secondary"
        loading={isExportingAdmins}
        onClick={() =>
          exportAdmins(activeNetwork.id).then((res) => {
            const isError = res.error;
            toast(
              isError
                ? 'There was an unexpected error, try again or send us a chat.'
                : 'Export in progress — we’ll email it to you in a few minutes.',
              { icon: isError ? 'error' : 'success', id: 'export-csv-success' },
            );

            if (!isError) {
              trackEvent('network_settings:export_admins_data');
            }
          })
        }
      >
        <Flex sx={{ columnGap: '10px' }} alignItems="center">
          <Box as={Download} height="16px" width="16px" aria-hidden="true" />
          Export admin list
        </Flex>
      </Button>
    </Box>
  );
};

export default ExportData;
